export function ContactUs(){

    return (
        <section className="pt-3 sm-pt-50px">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-5 col-lg-8 col-md-10 d-flex justify-content-center align-items-center"
                         data-anime='{ "el": "childs", "translateY": [30, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 250, "easing": "easeOutQuad" }'>
                        <div
                            className="lg-position-relative text-center ">
                            <div className="lg-position-relative text-start" style={{lineHeight: 1.0}}>
                                <h3 className="text-dark-gray ls-minus-2px fw-700">Az esemény helyszíne</h3>

                                <h5 className="text-start mt-4">Ajánljuk a tömegközlekedést:</h5>
                                <ul className="ps-3">
                                    <li className="mb-2">• 2-es villamossal a Széchenyi István téri megállótól 1 perc
                                        séta
                                    </li>
                                    <li className="mb-2">• Deák tértől induló 16-os busszal Széchényi István téri
                                        megállótól 1 perc séta
                                    </li>
                                    <li className="mb-2">• Kisföldalatti a Vörösmarty tértől 9 perc séta</li>
                                    <li className="mb-2">• Arany János utcai metrómegállótól 10 perc séta</li>
                                </ul>

                                <h5 className="text-start mt-4 mb-2">Autóval való érkezés:</h5>
                                <p className={'text-decoration-underline mb-2'}>A közeli parkolóházak:</p>
                                <ul className="ps-3">
                                    <li className="mb-2">• Bazilika mélygarázstól 7 perc séta</li>
                                    <li className="mb-2">• József nádor mélygarázstól 7 perc séta</li>
                                    <li className="mb-2">• Erzsébet téri mélygarázstól 11 perc séta</li>
                                </ul>
                                <p className="fw-600">FIGYELEM! A MTA épülete körüli közterületi parkolás építkezések
                                    miatt jelenleg nem lehetséges</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-8 col-md-10 offset-xl-1 d-flex align-items-center min-vh-100">
                        <div className="row row-cols-1 justify-content-center w-100"
                             data-anime={JSON.stringify({
                                 "el": "childs",
                                 "translateY": [30, 0],
                                 "opacity": [0, 1],
                                 "duration": 600,
                                 "delay": 0,
                                 "staggervalue": 150,
                                 "easing": "easeOutQuad"
                             })}>
                            <div className="col services-box-style-02 mb-30px">
                                <div className="row g-0 box-shadow-quadruple-large border-radius-6px overflow-hidden">
                                    <div className="col-lg-6 col-sm-6">
                                        <div className="h-100 cover-background xs-h-300px"
                                             style={{ backgroundImage: "url(/benefitshare/img/mta.png)" }}></div>
                                    </div>
                                    <div className="col-lg-6 col-sm-6 bg-white box-shadow-extra-large p-40px xl-p-30px">
                                        <div className="services-box-content last-paragraph-no-margin">
                                            <span className="d-block text-dark-gray primary-font fw-700 fs-19 mb-10px">BeneFit SHARE</span>
                                            <p className="mb-0">Magyar Tudományos Akadémia</p>
                                            <p>1051 Budapest, Széchenyi István tér 9</p>
                                            <a href="https://www.google.com/maps/place//data=!4m2!3m1!1s0x4741dc15e9640d91:0x38b9a91ec78416f4?sa=X&ved=1t:8290&ictx=111"
                                               target="_blank"
                                               className="fs-16 lh-20 primary-font fw-500 text-dark-gray text-decoration-line-bottom d-inline-block mb-25px mt-20px">
                                                Térkép megtekintése
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}